import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const BatteryThermalSimulatorGuidePage = () => <DataDrivenGuidePage slug="guide-battery-thermal-simulator" />;

export default BatteryThermalSimulatorGuidePage;
